module.exports = __webpack_public_path__ + "static/media/power-quiz-logo.98d6a532.png";